import salesforceBankServiceGet from "./api/SalesforceBankService";

async function getBankOptions() {
	const { data } = await salesforceBankServiceGet()

	return data;
}

export { getBankOptions };
